import { Capacitor } from '@capacitor/core';

/**
 * True in a browser, false inside the Capacitor shell on Android or a TV.
 *
 * Dev mode is gated on this: the editor is a mouse-and-keyboard tool, and a
 * tile brush driven by a remote on a television across the room is not an
 * editor anybody would use. It also keeps a stray press on the sofa from
 * rearranging the furniture for good.
 */
export function isWebPlatform(): boolean {
  return !Capacitor.isNativePlatform();
}
